import React, { useState, useEffect } from 'react';
import API from '../services/api';
import '../styles/RecentVisitors.css';

const RecentVisitors = () => {
  const [visitors, setVisitors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchVisitors = async () => {
    try {
      const data = await API.getRecentVisitors();
      if (data.success) {
        setVisitors(data.visitors);
      }
    } catch (error) {
      console.error('Error fetching recent visitors:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVisitors();
  }, []);

  if (isLoading) {
    return <div className="recent-visitors-loading">Loading visitors...</div>;
  }

  return (
    <div className="recent-visitors-section">
      <h2>Recent Visitors</h2>
      <div className="visitors-table-container">
        <table className="visitors-table">
          <thead>
            <tr>
              <th>IP Address</th>
              <th>Location</th>
              <th>Last Visit</th>
            </tr>
          </thead>
          <tbody>
            {visitors.map((visitor, index) => (
              <tr key={index}>
                <td className="ip-address">{visitor.ip_address}</td>
                <td className="location">{visitor.location}</td>
                <td className="visit-time">
                  {new Date(visitor.last_visit).toLocaleString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentVisitors;
